import { render, staticRenderFns } from "./newAction.vue?vue&type=template&id=0aec61ee&scoped=true"
import script from "./newAction.vue?vue&type=script&lang=js"
export * from "./newAction.vue?vue&type=script&lang=js"
import style0 from "./newAction.vue?vue&type=style&index=0&id=0aec61ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aec61ee",
  null
  
)

export default component.exports